import { V2ProtocolMetrics } from "~/components/v2/V2ProtocolMetrics";
import { V2HistoricalCharts } from "~/components/v2/V2HistoricalCharts";
import { V2AccountActivity } from "~/components/v2/V2AccountActivity";

export default function CoolerV2() {

  return (
    <div className="space-y-8">

      {/* Protocol Metrics */}
      <V2ProtocolMetrics />

      {/* Historical Charts */}
      <V2HistoricalCharts />

      {/* Account Activity */}
      <V2AccountActivity />
    </div>
  );
} 